const mailRegex = /^.+\@.+\..+/

export function isMail(str) {
  return str && mailRegex.test(str)
}
